import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { inventoryApi, fmtQty, localToday, MOVEMENT_LABELS } from './inventoryApi';

const fmtTime = (d) => new Date(d).toLocaleString('es-MX', { timeZone: 'America/Mexico_City', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

export const MovementsPanel = () => {
  const [date, setDate] = useState(localToday());
  const [type, setType] = useState('');
  const [list, setList] = useState([]);

  const load = useCallback(async () => {
    try { setList(await inventoryApi.movements({ date, type })); } catch (e) { toast.error(e.message); }
  }, [date, type]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2 items-center">
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="w-44 bg-black/50 border-gray-700 text-white" data-testid="movements-date" />
        <select value={type} onChange={(e) => setType(e.target.value)} className="h-10 rounded-md border bg-gray-950 border-gray-700 text-white [color-scheme:dark] px-3 text-sm" data-testid="movements-type">
          <option value="">Todos los tipos</option>
          {Object.entries(MOVEMENT_LABELS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
        <Button size="sm" variant="outline" onClick={load} data-testid="movements-refresh"><RefreshCw className="h-4 w-4" /></Button>
      </div>
      <div className="bg-gray-900/50 border border-gray-800 rounded-xl overflow-x-auto">
        {list.length === 0 ? (
          <p className="text-gray-500 text-center py-10" data-testid="movements-empty">Sin movimientos en esta fecha</p>
        ) : (
          <table className="w-full min-w-[760px] text-sm">
            <thead>
              <tr className="text-gray-500 text-xs text-left">
                <th className="py-2 px-3 font-medium">Hora</th><th className="py-2 px-3 font-medium">Insumo</th>
                <th className="py-2 px-3 font-medium">Tipo</th><th className="py-2 px-3 font-medium text-right">Cantidad</th>
                <th className="py-2 px-3 font-medium text-right">Existencia</th><th className="py-2 px-3 font-medium text-right">Costo</th>
                <th className="py-2 px-3 font-medium">Motivo</th>
              </tr>
            </thead>
            <tbody>
              {list.map((m) => (
                <tr key={m.id} className="border-t border-gray-800" data-testid={`movement-row-${m.id}`}>
                  <td className="py-2 px-3 text-gray-400 whitespace-nowrap">{fmtTime(m.created_at)}</td>
                  <td className="py-2 px-3 text-white">{m.item_name}</td>
                  <td className="py-2 px-3"><span className={`text-xs px-2 py-0.5 rounded-full ${MOVEMENT_LABELS[m.type]?.cls}`}>{MOVEMENT_LABELS[m.type]?.label || m.type}</span></td>
                  <td className={`py-2 px-3 text-right font-semibold ${m.quantity >= 0 ? 'text-emerald-300' : 'text-red-300'}`}>{m.quantity >= 0 ? '+' : ''}{fmtQty(m.quantity)} {m.unit}</td>
                  <td className="py-2 px-3 text-right text-gray-300">{fmtQty(m.stock_after)}</td>
                  <td className="py-2 px-3 text-right text-gray-300">${Number(m.total_cost || 0).toFixed(2)}</td>
                  <td className="py-2 px-3 text-gray-400">{m.reason || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
